import React, { createRef, useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';

//Material UI
import LinearProgress from '@material-ui/core/LinearProgress';

//Zustands
import { useMainStore } from 'useStores/useMainStore';

//APIs
import axios from '../../../../../../api/axios';

//Packages
import moment from 'moment-jalaali';
import { useQuery } from 'react-query';

//Hooks
import { useSearchParams } from 'hooks/useSearchParams';
import useRules from 'hooks/useRules';

//Utils
import { localText } from '../../../../../../langs/fa/data-grid';

//Functions
import formatNumber from '../../../../../../fns/formatNumber';

//Components
import { DataGrid } from '../../../../../../components/DataGrid/DataGrid';
import Avatar from '../../../../../../components/User/UserAvatar';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const List = () => {
  const ref = createRef();
  const history = useHistory();
  const [rules, hasRule, isAdmin] = useRules();
  const location = useLocation();
  const limit = useMainStore((state) => state.limit);
  const { id } = useParams();
  const [params, setParams] = useSearchParams();
  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 100,
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 120,
    },
    // {
    //   field: 'commissions',
    //   headerName: 'کارمزد شرکت',
    //   flex: 1,
    // },
    // {
    //   field: 'tracingCode',
    //   headerName: 'کد رهگیری',
    //   width: 150,
    // },
    {
      field: 'owner',
      headerName: ' صاحب بار',
      flex: 1,
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 150,
    },
  ];
  const columnAdmin = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'user',
      headerName: 'کاربر',
      flex: 1,
      renderCell: ({ value }) => (
        <>
          {value?._id ? (
            <Avatar user={value} fullName width={30} height={30} />
          ) : null}
        </>
      ),
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 110,
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 130,
    },
    {
      field: 'commissions',
      headerName: 'کارمزد شرکت',
      width: 150,
    },
    // {
    //   field: 'tracingCode',
    //   headerName: 'کد رهگیری',
    //   width: 150,
    // },
    {
      field: 'owner',
      headerName: ' صاحب بار',
      width: 150,
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      width: 150,
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 140,
    },
  ];

  const fetchCommission = async () => {
    const res = await axios.get(
      `/api/v1/admin/reports/getCommissionPaymentReport/user/${id}${location.search}&limit=${limit}`
    );
    return res.data;
  };

  const { data, isLoading } = useQuery(
    ['customCommission', window.location.search, id],
    () => fetchCommission(),
    {
      refetchOnWindowFocus: false,
    }
  );

  const _waybillType = {
    custom: 'سفارشی',
    police: 'پلیس راهی',
    software: 'کامل',
  };

  const handlePageChange = (page) => {
    setParams([{ name: 'page', value: page }]);
  };
  // const handleSelectRow = (selection) => {
  //   let orderId = data?.docs?.filter((x) => x._id == selection.row.id)[0];

  //   orderId = orderId?.order._id;

  //   // history.push(`/protected/admin/orders/${orderId}`);
  // };
  const handleCellClick = async (selection) => {
    if (selection.field !== 'user') {
      history.push(`/protected/admin/orders/${selection.row.id}`);
    }
    //  else
    //   history.push(
    //     `/protected/admin/reports/commissions/custom/${selection.row._id}`
    //   );
  };

  var _reports = data?.docs
    ? data.docs.map((report, i) => ({
        id: report?.order._id,
        rowNumber: ((params.get('page') * 1 || 1) - 1) * limit * 1 + (i + 1),
        user: report?.user,
        loadingDate: moment(report?.createdAt).format('jMM/jDD'),
        destination: report?.order?.destination?.title || '',
        waybillType: _waybillType[report?.order.waybillType] || '',
        commissions: formatNumber(report?.order?.commission) || '',
        owner: `${report?.order?.customer?.firstName} ${report?.order?.customer?.lastName}`,
        status: report.paidAt !== undefined ? 'پرداخت شده' : 'در انتظار پرداخت',
        commissionDeposit: formatNumber(report.amount),
      }))
    : [];

  return (
    <>
      <div style={isMobile ? {} : { height: 450 }} ref={ref}>
        {isLoading && <LinearProgress />}
        <DataGrid
          rows={isLoading ? [] : _reports}
          columns={isAdmin ? columnAdmin : columns}
          localeText={localText}
          pageSize={limit}
          rowCount={data?.totalDocs || 0}
          paginationMode="server"
          onPageChange={handlePageChange}
          loading={isLoading}
          disableMultipleSelection
          onCellClick={handleCellClick}
          pageNumber={params.get('page') * 1 || 1}
          density="compact"
          // onSelectionChange={handleSelectRow}
          footerPagination
        />
      </div>
    </>
  );
};

export default React.memo(List);
